export const OVER_LAY_HEADING =
    "my-[135px] sm:my-[75px] md:my-[75px] lg:my-[145px] bg-[#FFFFFF80] h-max w-full justify-center self-center text-center font-Playfair";

export const BACKGROUND_IMAGE_CONTAINER_CLASS =
    " w-full flex justify-center items-center bg-no-repeat  bg-contain bg-center bg-transparent";

export const BREAK_POINT_WIDTH = 425;
